import { CIDADES_ATENDIDAS } from "@/content/site";

const ITEMS = CIDADES_ATENDIDAS.map((c) => c.toUpperCase());

const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-coal py-6">
    <div className="animate-marquee flex w-max items-center whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center font-serif text-lg italic text-stone-500">
          <span className="px-8">{item}</span>
          <span className="text-xs text-sun">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
